module.exports = __webpack_public_path__ + "media/images/aloe/logo/nephos-purple-0cd78e96079b0253572835cc528e9d8c.svg";